<template>
  <div>
    <div style="margin-top:50px;">
      <h1 align=center style='text-align:center'><span lang=EN-US>JRC</span>雷达在线学习系统使用说明</h1>
    </div>
    <div>
      <p class=MsoNormal><b>安装步骤：<span lang=EN-US>
            <o:p></o:p>
          </span></b></p>
      <p class=MsoNormal>
        1.在线雷达学习初次使用需要下载客户端程序安装包（雷达安装包.zip）</p>
    </div>
    <div>
      <img border=0 width=492 height=216 src="../assets/images/雷达安装说明.files/image010.jpg">
    </div>

    <div>
      <p class=MsoNormal> 2.解压(雷达安装包.zip)</p>
    </div>
    <div>
      <img border=0 width=428 height=126 src="../assets/images/雷达安装说明.files/image011.jpg">
    </div>
    <div>
      <p class=MsoNormal> 3.安装完成后会在桌面创建快捷方式</p>
    </div>
    <div>
      <img border=0 width=112 height=94 src="../assets/images/雷达安装说明.files/image005.png">
    </div>
    <div>
      <p class=MsoNormal>
        <p class=MsoNormal> 4.启动程序</p>
        <p class=MsoNormal>输入用户名和密码进行登录</p>
    </div>
    <div>
      <img border=0 width=429 height=290 src="../assets/images/雷达安装说明.files/image012.jpg">
    </div>
    <div style="margin-top:20px;">
      <img border=0 width=554 height=346 src="../assets/images/雷达安装说明.files/image013.jpg">
    </div>
    <br />
  </div>
</template>

<script>
  export default {
    name: "JRS",
    components: {}
  }

</script>

<style scoped>
  .MsoNormal {
    margin-left: 25%;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/pages/JRS.vue